export function canDropEngagement(params) {
    if (params.placementMode !== 'MANUAL') {
        return false;
    }
    if (params.card.status !== 'ACTIVE') {
        return false;
    }
    if (params.sourceStageCode === params.targetStageCode) {
        return false;
    }
    const sorted = [...params.columns].sort((a, b) => a.order - b.order);
    const sourceIndex = sorted.findIndex((column) => column.stageCode === params.sourceStageCode);
    const targetIndex = sorted.findIndex((column) => column.stageCode === params.targetStageCode);
    if (sourceIndex < 0 || targetIndex < 0) {
        return false;
    }
    return targetIndex === sourceIndex + 1;
}
export function nextStageCode(columns, sourceStageCode) {
    const sorted = [...columns].sort((a, b) => a.order - b.order);
    const sourceIndex = sorted.findIndex((column) => column.stageCode === sourceStageCode);
    if (sourceIndex < 0) {
        return null;
    }
    return sorted[sourceIndex + 1]?.stageCode ?? null;
}
